import React, { Component, Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Row, Col, Button, Form, FormGroup } from 'react-bootstrap';

import Toggle from 'react-toggle';
import ReactGA4 from 'react-ga4';

import config from '../../../../config.js';

import { setCartItem, removeItem, getCartItemByProduct, getCartItemFromProduct, formatAnalyticsItems, getCartQuantityStep, setCartSubscriptionActive } from '../../CartActions.js';
import { getProductOption, getProductPrice, memoizedGetProducts } from '../../../Product/ProductActions.js';
import { getCurrentCurrency, defaultCurrency } from '../../../Currency/CurrencyActions.js';
import { getTranslation } from '../../../Intl/IntlHelper.js';
import { addUserInterestsRequest, getCurrentUserData } from '../../../User/UserActions.js';
import { getUserGroup, doesUserGroupHasCondition, getUserGroupCondition } from '../../../User/UserGroupActions.js';
import { getReferral, setStatusCode } from '../../../App/AppActions.js';

// import PaypalMessagePayIn4 from '../../../Payment/components/paypal/PaypalMessagePayIn4.js';
import Icon from '../../../../components/Content/Icon.js';
import ProductSpecialPriceQuantityInfo from '../../../Product/components/view/ProductSpecialPriceQuantityInfo.js';
import ProductSubscription from '../view/ProductSubscription.js';
import GamifiedButton from '../../../../components/Content/GamifiedButton.js';

function CartItemQuantitySelector({ dispatch, intl, product, variation = null, item = null, products = [], userData = {}, userGroup = null, disableQuantityEdition = false, disableCustomization = false, disableSubscription = false, disableExtraMessages = false, needFillBox = false, buttonColor = null, referral = null, currency = defaultCurrency, onCart = false, onAddToCart = null, onChangeVariation = null }) {
	const [mounted, setMounted] = useState(false);
	const [customizations, setCustomizations] = useState(item?.customizations || {});

	useEffect(() => {
		setMounted(true);
	}, []);

	useEffect(() => {
		if(item) {
			dispatch(setCartItem({ ...item, customizations }));
		}
	}, [customizations]);

	useEffect(() => {
		if(item && Object.keys(item.customizations || {}).length && !Object.keys(customizations || {}).length) {
			setCustomizations(item.customizations);
		}
	}, [mounted]);

    const getProduct = () => {
        return variation || product;
    };

    const handleTrackAnalytics = (quantity, diff = 0) => {
        if(diff !== 0) {
            const product = getProduct();
            const productPrice = getProductPrice(product, 1, userGroup, true, referral);
            if(typeof window !== 'undefined' && config.google.analytics.trackingCodeGA4) {
                // console.log('Analytics::: Track add_to_cart', quantity, diff);

                // GA: New
                ReactGA4.event(diff > 0 ? 'add_to_cart' : 'remove_from_cart', {
                    currency,
                    value: productPrice,
                    items: formatAnalyticsItems([item || { ...product, priceTTC: productPrice, quantity }]),
                });
            }
            if(typeof window !== 'undefined' && window.fbq) {
                diff > 0 && window.fbq('track', 'AddToCart', {
                    content_name: product.name,
                    content_ids: [product.slug || product._id],
                    content_type: 'product',
                    value: productPrice,
                    currency,
                });
            }

            dispatch(addUserInterestsRequest(userData, product.categories));
        }
    };

    const handleAddToCart = newQuantity => {
        onAddToCart && onAddToCart(newQuantity);
    };

    const handleChangeQuantity = newQuantity => {
		console.log('handleChangeQuantity', newQuantity);
        if(newQuantity > 0) {
			const itemCustomizations = {};
			(getProduct().customizations || []).forEach(customization => {
				if(customizations[customization.name] !== 'undefined') {
					itemCustomizations[customization.name] = customizations[customization.name];
				}
			});
			dispatch(setCartItem(getCartItemFromProduct(
				{
					...getProduct(),
					variationParentId: variation && (product || {})._id,
					customizations: itemCustomizations,
				},
				newQuantity,
				intl.locale,
				userGroup,
				{ referral },
			)));
            handleAddToCart(newQuantity);
        } else {
			dispatch(removeItem(item));
        }
		handleTrackAnalytics(newQuantity, newQuantity - ((item || {}).quantity || 0));
    };

    const handleSubtract = () => {
        if((item || {}).quantity > 0) {
            let newQuantity = (item || {}).quantity - getCartQuantityStep(getProduct(), userGroup);
            if(getProduct().minimumQuantity && newQuantity < getProduct().minimumQuantity) {
                newQuantity = 0;
            } else {
                newQuantity = Math.max(getProduct().minimumQuantity || 1, newQuantity);
            }
            handleChangeQuantity(newQuantity);
        }
    };

    const handleAdd = event => {
		event && event.stopPropagation();
		const product = getProduct();
		const newQuantity = Math.max(product.minimumQuantity || 1, ((item || {}).quantity || 0) + getCartQuantityStep(product, userGroup));
		console.log(newQuantity, product.maximumQuantity, product.maximumQuantity || Infinity);
        handleChangeQuantity(Math.min(product.maximumQuantity || Infinity, newQuantity));
    };

    const handleChange = event => {
		if((!product.maximumQuantity || event.target.value <= product.maximumQuantity) && (!product.minimumQuantity || event.target.value >= product.minimumQuantity)) {
			handleChangeQuantity(event.target.value);
		}
    };

    const handleFillBox = () => {
        const product = getProduct();
        handleChangeQuantity(item ? (Math.ceil(item.quantity / item.packing) * item.packing) : product.packing);
    };

	const handleSubscribe = event => {
		!item?.quantity && handleAdd(event);
		dispatch(setCartSubscriptionActive());
	};

	const handleUnsubscribe = () => {
		dispatch(setCartSubscriptionActive(false));
	};

    const renderVariations = () => {
        if(!onCart && (product.variations || []).length && onChangeVariation) {
            const variations = product.variations.filter(variation => {
                const product = products.find(product => product._id === variation.productId);
                return product && (!(getProductOption(product, 'visibleGroups') || []).length || getProductOption(product, 'visibleGroups').includes((userGroup || {}).identifier));
            });
            if(variations.length) {
				const defaultVariationName = getTranslation(product.variations.find(variation => !variation.productId), 'label', intl.locale);
                return (
					<div className="mb-3">
						<Form.Select name="variation" value={(item || {}).productId || (variation || product)._id || ''} onChange={event => onChangeVariation(event.target.value)}>
							{(defaultVariationName ? <option value="">{defaultVariationName}</option> : <FormattedMessage id="selectOptions" defaultMessage="Select an option">{message => <option value="">{message}</option>}</FormattedMessage>)}
							{variations.map((variation, index) => (
								<option key={variation.productId} value={variation.productId}>{getTranslation(variation, 'label', intl.locale)}</option>
							))}
						</Form.Select>
					</div>
                );
            }
        }
    };

	const renderCustomizations = () => {
		const product = getProduct();
		const handleChangeCustomization = (customization, value, valueLabel = '') => {
			setCustomizations({
				...(customizations || {}),
				[customization.name]: {
					name: customization.name,
					type: customization.type,
					label: getTranslation(customization, 'label', intl.locale),
					value,
					valueLabel,
					sort: customization.sort,
				},
			});
		};
		if(!disableCustomization && !onCart && (product?.customizations || []).length) {
			return product.customizations.map(customization => {
				let input = <Form.Control id={`product-customization-${customization.id}`} type="text" name={customization.name} value={customizations[customization.name]?.value} placeholder={intl.formatMessage({ id: 'inputTextPlaceholder', defaultMessage: 'Enter a value' })} onChange={event => handleChangeCustomization(customization, event.target.value)} />;
				if(customization.type === 'textarea') {
					input = <Form.Control id={`product-customization-${customization.id}`} as="textarea" name={customization.name} value={customizations[customization.name]?.value} placeholder={intl.formatMessage({ id: 'inputTextPlaceholder', defaultMessage: 'Enter a value' })} onChange={event => handleChangeCustomization(customization, event.target.value)} />;
				}
				if(customization.type === 'select') {
					input = (
						<Form.Select id={`product-customization-${customization.id}`} name={customization.name} value={customizations[customization.name]?.value} onChange={event => handleChangeCustomization(customization, event.target.value, getTranslation(customization.options.find(option => option.value === event.target.value), 'label', intl.locale))}>
							<FormattedMessage id="selectOptions" defaultMessage="Select an option">
								{message => <option>{message}</option>}
							</FormattedMessage>
							{customization.options.map(option => <option key={option.value} value={option.value}>{getTranslation(option, 'label', intl.locale)}</option>)}
						</Form.Select>
					);
				}
				if(customization.type === 'toggle') {
					input = (
						<Fragment>
							<br />
							<Toggle
								id={`product-customization-${customization.id}`}
								name={customization.name}
								checked={!!customizations[customization.name]?.value}
								onChange={event => handleChangeCustomization(customization, event.target.checked)}
							/>
						</Fragment>
					);
				}
				return (
					<FormGroup key={customization.id} className="mb-2">
						<Form.Label for={`product-customization-${customization.id}`}>{getTranslation(customization, 'label', intl.locale)}</Form.Label>
						{input}
					</FormGroup>
				);
			});
		}
		return null;
	};

	const quantity = mounted && item ? item.quantity : 0;
	return (
		<Fragment>
			{renderVariations()}

			{renderCustomizations()}

			<small className="d-block text-center text-md-start">
				{(product.minimumQuantity || 1) > getCartQuantityStep(getProduct(), userGroup) && <em className="d-block"><Icon icon="info" /> <FormattedMessage id="productMinimumQuantityAlert" defaultMessage="The minimum purchase quantity is {count} pieces" values={{ count: product.minimumQuantity }} /></em>}
				{product.maximumQuantity > 0 && getCartQuantityStep(getProduct(), userGroup) > product.maximumQuantity && <em className="d-block"><Icon icon="info" /> <FormattedMessage id="productMaximumQuantityAlert" defaultMessage="The maximum purchase quantity is {count} pieces" values={{ count: product.maximumQuantity }} /></em>}
				{(product.stepQuantity || 1) > getCartQuantityStep(getProduct(), userGroup) && <em className="d-block"><Icon icon="info" /> <FormattedMessage id="producStepQuantityAlert" defaultMessage="Purchase in increments of {count} pieces" values={{ count: product.stepQuantity }} /></em>}
			</small>
			<Row className="mb-1 text-center text-lg-start">
				{!disableQuantityEdition && (quantity > 0 || onCart) && (
					<Col xs="12" xl={onCart ? 12 : 4}>
						{false && <span className="d-block mb-2 text-primary"><FormattedMessage id="quantity" defaultMessage="Quantity" /></span>}

						<div className="d-flex px-3 px-md-2 bg-info rounded rounded-2">
							<span><Button variant="link" size="sm" className="px-0 px-md-2 qty-control" onClick={handleSubtract} disabled={quantity <= 0 && quantity <= product.minimumQuantity}><Icon icon="remove" /></Button></span>
							<Form.Control type="text" name="quantity" size="sm" value={quantity} disabled={getCartQuantityStep(getProduct(), userGroup) !== 1} className="border-0 bg-info text-dark text-center font-weight-bold text-lg" onChange={handleChange} />
							<span><Button variant="link" size="sm" className="px-0 px-md-2 qty-control" onClick={handleAdd} disabled={product.maximumQuantity && quantity >= product.maximumQuantity}><Icon icon="add" /></Button></span>
						</div>

						{false && needFillBox && (
							<Button variant="link" block size="sm" className="m-0 mt-1 p-0" onClick={handleFillBox}><Icon icon="box" /> <FormattedMessage id="cartItemBoxFill" defaultMessage="Fill the box" /></Button>
						)}
					</Col>
				)}
				{!onCart && (
					<Col className="text-center text-lg-end">
						<div className="d-grid">
							<GamifiedButton as={Button} variant={buttonColor || 'secondary'} size="lg" className="rounded-sm mt-1 add-to-cart" onClick={handleAdd} disabled={product.maximumQuantity && quantity >= product.maximumQuantity}><Icon icon="shopping-cart" /> <FormattedMessage id="cartAddTo" defaultMessage="Add to cart" /></GamifiedButton>
							{quantity > 0 && <Button variant="link" size="lg" className="text-success see-cart" as={Link} to={`/${intl.locale}/cart`}><FormattedMessage id="cartSee" defaultMessage="See my cart" /> <Icon icon="chevron-right" /></Button>}
						</div>
						{/* {!disableExtraMessages && <PaypalMessagePayIn4 amount={getProductPrice(product, quantity, userGroup, true, referral)} />} */}
					</Col>
				)}
			</Row>
			{onCart && <ProductSpecialPriceQuantityInfo product={product} />}
			{!disableSubscription && <ProductSubscription product={product} variation={variation} onCart={onCart} onSubscribe={handleSubscribe} onUnSubscribe={handleUnsubscribe} />}
		</Fragment>
	);
}

function mapStateToProps(store, props) {
    return {
        currency: getCurrentCurrency(store),
        userData: getCurrentUserData(store),
        userGroup: getUserGroup(store),
        products: memoizedGetProducts(store, { isActive: true, isVariation: true }),
        item: getCartItemByProduct(store, props.variation || props.product),
        needFillBox: doesUserGroupHasCondition(store, 'packFill'),
        referral: getReferral(store),
    };
}

CartItemQuantitySelector.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    currency: PropTypes.string,
    userData: PropTypes.object,
    product: PropTypes.object.isRequired,
    variation: PropTypes.object,
    userGroup: PropTypes.object,
    products: PropTypes.arrayOf(PropTypes.object),
    item: PropTypes.object,
    onCart: PropTypes.bool,
    disableQuantityEdition: PropTypes.bool,
    disableCustomization: PropTypes.bool,
    disableExtraMessages: PropTypes.bool,
    disableSubscription: PropTypes.bool,
    onAddToCart: PropTypes.func,
    onChangeVariation: PropTypes.func,
    needFillBox: PropTypes.bool,
    buttonColor: PropTypes.string,
    referral: PropTypes.string,
};

export default connect(mapStateToProps)(injectIntl(CartItemQuantitySelector));
